import { createAction, props } from '@ngrx/store';
import { FetchArgs, PagingTokenFixed } from 'src/app/shared/models/core';
import {
    BulkQmAssociationAssignmentChange,
    BulkUnassignAssignmentChange,
    BulkUserAssignmentChange
} from 'src/app/shared/models/user-assignment-change-request.model';
import { ClientPortalVisibilityUpdate } from '../../models/client-portal-visibility-update.model';
import { DocDueDate } from '../../models/doc-due-date.model';
import { QmAssociationDto, QmAssociationGridItem } from '../../models/qm-association.model';
import { QmAssociationChange } from 'src/app/shared/models/qm-association.model';
import { ClientPortalVisibilitySettings } from '../../models/client-portal-visibility-settings.model';
import { QmAssociationAutoMatchSettingsViewModel } from '../../models/qm-association-auto-match-settings-dto.model';

export const getQmAssociations = createAction(
    '[QMASSOCIATION COMPONENT] Get QmAssociations',
    props<{ args: FetchArgs }>()
);
export const getQmAssociationsSuccess = createAction(
    '[QMASSOCIATION API] Get QmAssociations Success',
    props<{ associations: PagingTokenFixed<QmAssociationGridItem[]> }>()
);
export const getQmAssociationsFailure = createAction(
    '[QMASSOCIATION API] Get QmAssociations Failure',
    props<{ error: any }>()
);

export const getQmAssociation = createAction(
    '[QMASSOCIATION DETAILS COMPONENT] Get QmAssociation',
    props<{ id: number }>()
);
export const getQmAssociationSuccess = createAction(
    '[QMASSOCIATION API] Get QmAssociation Success',
    props<{ association: QmAssociationDto }>()
);
export const getQmAssociationFailure = createAction(
    '[QMASSOCIATION API] Get QmAssociation Failure',
    props<{ error: any }>()
);

export const getQmAssociationClientPortalVisibilitySettings = createAction(
    '[CLIENT PORTAL VISIBILITY COMPONENT] Get QmAssociation Client Portal Visibility Settings',
    props<{ id: number }>()
);
export const getQmAssociationClientPortalVisibilitySettingsSuccess = createAction(
    '[QMASSOCIATION API] Get QmAssociation Client Portal Visibility Settings Success',
    props<{ clientPortalVisibilitySettings: ClientPortalVisibilitySettings }>()
);
export const getQmAssociationClientPortalVisibilitySettingsFailure = createAction(
    '[QMASSOCIATION API] Get QmAssociation Client Portal Visibility Settings Failure',
    props<{ error: unknown }>()
);

export const updateQmAssociationClientPortalVisibilitySettings = createAction(
    '[CLIENT PORTAL VISIBILITY COMPONENT] Update QmAssociation Client Portal Visibility Settings',
    props<{ id: number; updates: ClientPortalVisibilityUpdate[] }>()
);
export const updateQmAssociationClientPortalVisibilitySettingsSuccess = createAction(
    '[QMASSOCIATION API] Update QmAssociation Client Portal Visibility Settings Success',
    props<{ id: number }>()
);
export const updateQmAssociationClientPortalVisibilitySettingsFailure = createAction(
    '[QMASSOCIATION API] Update QmAssociation Client Portal Visibility Settings Failure',
    props<{ error: unknown }>()
);

export const getDocDueDate = createAction(
    '[QMASSOCIATION REQUIREMENTS COMPONENT] Get Doc Due Date ',
    props<{ id: number }>()
);
export const getDocDueDateSuccess = createAction(
    '[QMASSOCIATION API] Get Doc Due Date Success',
    props<{ docDueDate: DocDueDate }>()
);
export const getDocDueDateFailure = createAction(
    '[QMASSOCIATION API] Get Doc Due Date Failure',
    props<{ error: unknown }>()
);

export const createQmAssociation = createAction(
    '[QMASSOCIATION API] Create QM Association',
    props<{ association: QmAssociationChange }>()
);

export const createQmAssociationSuccess = createAction('[QMASSOCIATION API] Create QM Association Success');

export const createQmAssociationFailure = createAction(
    '[QMASSOCIATION API] Create QM Association Failure',
    props<{ error: unknown }>()
);

export const updateQmAssociationName = createAction(
    '[QMASSOCIATION API] Update QM Association Name',
    props<{ id: number; association: QmAssociationChange }>()
);

export const updateQmAssociationNameSuccess = createAction(
    '[QMASSOCIATION API] Update QM Association Name Success',
    props<{ id: number }>()
);

export const updateQmAssociationNameFailure = createAction(
    '[QMASSOCIATION API] Update QM Association Name Failure',
    props<{ error: unknown }>()
);

export const updateDocDueDate = createAction(
    '[QMASSOCIATION REQUIREMENTS COMPONENT] Update Doc Due Date',
    props<{ id: number; docDueDate: DocDueDate }>()
);
export const updateDocDueDateSuccess = createAction(
    '[QMASSOCIATION API] Update Doc Due Date Success',
    props<{ id: number }>()
);
export const updateDocDueDateFailure = createAction(
    '[QMASSOCIATION API] Update Doc Due Date Failure',
    props<{ error: unknown }>()
);

export const updateIsComplete = createAction(
    '[QMASSOCIATION REQUIREMENTS COMPONENT] Update IsComplete',
    props<{ id: number; isComplete: boolean }>()
);
export const updateIsCompleteSuccess = createAction(
    '[QMASSOCIATION API] Update IsComplete Success',
    props<{ id: number }>()
);
export const updateIsCompleteFailure = createAction(
    '[QMASSOCIATION API] Update IsComplete Failure',
    props<{ error: unknown }>()
);

export const bulkUnassignComplianceLiaisonFromQmAssociation = createAction(
    '[QM ASSOCIATION GRID COMPONENT] Bulk Unassign Compliance Liaison',
    props<{ bulkUnassignAssignment: BulkUnassignAssignmentChange }>()
);

export const bulkUnassignComplianceLiaisonFromQmAssociationSuccess = createAction(
    '[CONTRACT ASSIGNMENTS API] Bulk Unassign Compliance Liaison Success'
);

export const bulkUnassignComplianceLiaisonFromQmAssociationFailure = createAction(
    '[CONTRACT ASSIGNMENTS API] Bulk Unassign Compliance Liaison Failure',
    props<{ error: unknown }>()
);

export const bulkUpdateComplianceLiaisonFromQmAssociation = createAction(
    '[QM ASSOCIATION GRID COMPONENT] Bulk Update Compliance Liaison',
    props<{ bulkAssignment: BulkUserAssignmentChange }>()
);

export const bulkUpdateComplianceLiaisonFromQmAssociationSuccess = createAction(
    '[CONTRACT ASSIGNMENTS API] Bulk Update Compliance Liaison Success'
);

export const bulkUpdateComplianceLiaisonFromQmAssociationFailure = createAction(
    '[CONTRACT ASSIGNMENTS API] Bulk Update Compliance Liaison Failure',
    props<{ error: unknown }>()
);
export const bulkQmAssociationAssignmentChange = createAction(
    '[FACILITIES QM ASSOCIATION EDIT API] Bulk Qm Association Assignment Change',
    props<{ bulkQmAssociationAssignmentChange: BulkQmAssociationAssignmentChange }>()
);
export const bulkQmAssociationAssignmentChangeSuccess = createAction(
    '[FACILITIES QM ASSOCIATION EDIT API] Bulk Qm Association Assignment Change Success'
);
export const bulkQmAssociationAssignmentChangeFailure = createAction(
    '[FACILITIES QM ASSOCIATION EDIT API] Bulk Qm Association Assignment Change Failure',
    props<{ error: unknown }>()
);

export const getAssociationAutomatchSettings = createAction(
    '[QM ASSOCIATIONS COMPONENT] Get Automatch Settings For Association',
    props<{ associationId: number }>()
);

export const getAssociationAutomatchSettingsSuccess = createAction(
    '[QM ASSOCIATIONS API] Get Automatch Settings For Association Success',
    props<{ settings: QmAssociationAutoMatchSettingsViewModel }>()
);

export const getAssociationAutomatchSettingsFailure = createAction(
    '[QM ASSOCIATIONS API] Get Automatch Settings For Association Failure',
    props<{ error: unknown }>()
);

export const updateAssociationAutomatchSettings = createAction(
    '[QM ASSOCIATIONS COMPONENT] Update Automatch Settings For Association',
    props<{ settings: QmAssociationAutoMatchSettingsViewModel }>()
);

export const updateAssociationAutomatchSettingsSuccess = createAction(
    '[QM ASSOCIATIONS API] Update Automatch Settings For Association Success',
    props<{ settings: QmAssociationAutoMatchSettingsViewModel }>()
);

export const updateAssociationAutomatchSettingsFailure = createAction(
    '[QM ASSOCIATIONS API] Update Automatch Settings For Association Failure',
    props<{ error: unknown }>()
);

export const clearLocalAssociationAutomatchSettings = createAction(
    '[QM ASSOCIATIONS COMPONENT] Clear Local QM Association Automatch Settings'
);
